import { GNS } from '../core/GNS.js';

/**
 * GNS.DOM
 * 
 * DOM要素の操作を補助するユーティリティ集
 * 
 * 主要メソッド:
 * - getElement(id): 要素取得（getElementById）
 * - getPosition(element, parent): 要素の位置取得
 * - getRect(element, parent): 要素の矩形取得
 * - addEvent(element, type, callback): イベント追加
 * - removeEvent(element, type, callback): イベント削除
 * - getPageSize(): ページサイズ取得
 * - onLoad(element, callback, errorCallback): 読み込み完了時の処理
 */
GNS.DOM = function (a) {
    var b = a.create();
    return b._static.getElement = function (a) {
        return document.all && document.all(a) || document.getElementById && document.getElementById(a)
    }, b._static.getPosition = function (a, b) {
        var c = {
            x: 0,
            y: 0
        };
        do c.x += a.offsetLeft || 0, c.y += a.offsetTop || 0, a = a.offsetParent, b && a == b && (a = null); while (a);
        return c
    }, b._static.getRect = function (a, c) {
        var d = b._static.getPosition(a, c);
        return d.width = a.offsetWidth, d.height = a.offsetHeight, d
    }, b._static.addEvent = function (a, b, c) {
        return a && b && c ? void (a.addEventListener ? a.addEventListener(b, c, !1) : a.attachEvent ? a.attachEvent(
            "on" + b, c) : a["on" + b] = c) : null
    }, b._static.removeEvent = function (a, b, c) {
        return a && b && c ? void (a.removeEventListener ? a.removeEventListener(b, c, !1) : a.detachEvent("on" + b,
            c)) : null
    }, b._static.getPageSize = function () {
        // モダンブラウザAPIを優先的に使用（クロスブラウザ対応）
        var scrollX = window.pageXOffset !== undefined ? window.pageXOffset :
            (document.documentElement.scrollLeft || document.body.scrollLeft);
        var scrollY = window.pageYOffset !== undefined ? window.pageYOffset :
            (document.documentElement.scrollTop || document.body.scrollTop);
        var displayWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        var displayHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;

        // ページ全体のサイズを取得（スクロール領域全体）
        var docElement = document.documentElement;
        var body = document.body;
        var stageWidth = Math.max(
            body.scrollWidth, docElement.scrollWidth,
            body.offsetWidth, docElement.offsetWidth,
            body.clientWidth, docElement.clientWidth
        );
        var stageHeight = Math.max(
            body.scrollHeight, docElement.scrollHeight,
            body.offsetHeight, docElement.offsetHeight,
            body.clientHeight, docElement.clientHeight
        );

        return {
            stageWidth: stageWidth,
            stageHeight: stageHeight,
            displayWidth: displayWidth,
            displayHeight: displayHeight,
            scrollX: scrollX,
            scrollY: scrollY
        };
    }, b._static.onLoad = function (a, b, c) {
        "onreadystatechange" in a ? a.onreadystatechange = function (d) {
            "loaded" === a.readyState || "complete" === a.readyState ? (a.onreadystatechange = null, b && b()) :
                "uninitialized" === a.readyState && c && c()
        } : (b && (a.onload = b), c && (a.onerror = c))
    }, b._self
}(GNS);
